import moment from 'moment';

export default function relativeTime(timestamp, short) {
  const midday = moment().startOf('day').hour(12);
  const mom = moment(timestamp);
  let result = '';
  if (timestamp && timestamp.length && mom.isValid()) {
    result = Math.abs(mom.diff(midday, 'days'))
      ? mom.format(short ? 'D MMM YY' : 'Do MMM, YY')
      : mom.fromNow();
  }
  return result;
}
